import { Observable } from 'rxjs';
import { ConfigurationsModelKeys } from '../models/configurations.model';

export abstract class ConfigurationsRepository {
    abstract getConfig<T>(config: ConfigurationsModelKeys): Observable<T>;
}
